import { hideLoader } from "action/loader/hideLoader";
import { setProductDeliveryDetails } from "action/utils/setProductDeliveryDetails";
import { getProductDeliveryDetailsSkuApi } from "api/product/getProductDeliveryDetailsSkuApi";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeliveryOptions from "./DeliveryOptions";
import styles from "./product-delivery.module.scss";

const PostalCode = dynamic(() => import(/* webpackChunkName: "old-postal-code" */ "component/design-system/badge/PostalCode"));

const ProductDelivery = (props: any) => {
  const { product, name } = props;
  const dispatch = useDispatch();
  const router = useRouter();

  const { pickUpLocations, postalCode, hasRefreshed } = useSelector((store: RootState) => store.shoppingCart);
  const { t } = useTranslation("product");

  const [productDeliveryOptions, setProductDeliveryOptions] = useState();
  const getDeliveryDetails = () => {
    const { sku } = product;
    // this.props.showLoader();
    // postalCode should not be null
    getProductDeliveryDetailsSkuApi(sku, postalCode, 1)
      .then(({ data }: any) => {
        // this.props.hideLoader();
        if (!data.success) {
          router.replace("/page-not-found");
        } else {
          const { productDeliveryDetails } = data;
          dispatch(setProductDeliveryDetails(productDeliveryDetails.availableDeliveryMethodsDetails));
          setProductDeliveryOptions(productDeliveryDetails.availableDeliveryMethodsDetails);
        }
      })
      .catch(() => {
        dispatch(hideLoader());
      });
  };

  useEffect(() => {
    if (hasRefreshed) {
      getDeliveryDetails();
    }
  }, [postalCode, hasRefreshed]);

  const pickupLocation = pickUpLocations && pickUpLocations.length > 0
    ? pickUpLocations[0].name
    : null;

  return (
    <div className={`p-t-10 p-b-10 ${styles.product_delivery}`}>

      <PAText component="h4" fontSize={FONT_SIZE[2]} className="m-b-5">

        <b className="color-black">{t("Delivery")}</b>
      </PAText>

      <div className={`hidden-xs ${styles.vcenter}`} />

      <div className={`${styles.vcenter}`}>
        <PostalCode />
      </div>

      <DeliveryOptions
        productDeliveryOptions={productDeliveryOptions}
        pickupLocation={pickupLocation}
        name={name}
      />
    </div>
  );
};

ProductDelivery.propTypes = {
  product: PropTypes.object.isRequired,
};
export default ProductDelivery;
